import { ICheckboxSelectOption } from 'src/components/filter/types/filter.types'

export const defaultLimit = 50
export const defaultPage = 0
export const defaultSort = 'scan.created_at-desc'

export const sortOptions = [
  {
    label: 'sort-created-desc.v',
    value: 'scan.created_at-desc',
  },
  {
    label: 'sort-created-asc.v',
    value: 'scan.created_at-asc',
  },
]

export const scansChecboxOptions: ICheckboxSelectOption[] = [
  {
    label: 'scan-filter-own',
    queryParamName: 'own',
  },
]
